export enum Languages {
  RU = 'RU',
}
